// extracted by mini-css-extract-plugin
export default {"group":"index_group__NtP-7"};